__turbopack_context__.v({
  "availabilityMessage": "StoreAvailability-module-scss-module__SUjjNG__availabilityMessage",
  "availabilityMessageContainer": "StoreAvailability-module-scss-module__SUjjNG__availabilityMessageContainer",
  "availabilityText": "StoreAvailability-module-scss-module__SUjjNG__availabilityText",
  "availableInOtherStores": "StoreAvailability-module-scss-module__SUjjNG__availableInOtherStores",
  "availableInOtherStoresButton": "StoreAvailability-module-scss-module__SUjjNG__availableInOtherStoresButton",
  "high": "StoreAvailability-module-scss-module__SUjjNG__high",
  "low": "StoreAvailability-module-scss-module__SUjjNG__low",
  "medium": "StoreAvailability-module-scss-module__SUjjNG__medium",
  "outOfStockStoreName": "StoreAvailability-module-scss-module__SUjjNG__outOfStockStoreName",
  "secondLine": "StoreAvailability-module-scss-module__SUjjNG__secondLine",
  "stockLevelContainer": "StoreAvailability-module-scss-module__SUjjNG__stockLevelContainer",
  "stockLevelMessage": "StoreAvailability-module-scss-module__SUjjNG__stockLevelMessage",
  "storeNameButton": "StoreAvailability-module-scss-module__SUjjNG__storeNameButton",
});
